import Vue from 'vue'
import Router from 'vue-router'
const Koc = resolve => import('@/components/koc/koc').then(module => resolve(module))
const KocHistory = resolve => import('@/components/koc/koc_history').then(module => resolve(module))
const KocDetails = resolve => import('@/components/koc/koc_details').then(module => resolve(module))
const Me = resolve => import('@/components/koc/me').then(module => resolve(module))
const MeNotice = resolve => import('@/components/koc/me_notice').then(module => resolve(module))
const NotesDetails = resolve => import('@/components/koc/notes_details').then(module => resolve(module))
const AccountDetails = resolve => import('@/components/koc/account_details').then(module => resolve(module))
const AccountBank = resolve => import('@/components/koc/account_bank').then(module => resolve(module))
const NotesMaterial = resolve => import('@/components/koc/notes_material').then(module => resolve(module))
const FileUpload = resolve => import('@/components/koc/file_upload').then(module => resolve(module))
// const KocLogin = resolve => import('@/components/koc/koc_login').then(module => resolve(module))
const KocWechatService = resolve => import('@/components/koc/wechat_service').then(module => resolve(module))
const XhsUpload = resolve => import('@/components/koc/xhs_upload').then(module => resolve(module))
const BrandArticleLogin = resolve => import('@/components/brand_article/brand_article_login.vue').then(module => resolve(module))
const BrandArticleHome = resolve => import('@/components/brand_article/brand_article_home.vue').then(module => resolve(module))
const BrandArticleNote = resolve => import('@/components/brand_article/brand_article_note.vue').then(module => resolve(module))
const BrandArticleNoteDetail = resolve => import('@/components/brand_article/brand_article_note_detail.vue').then(module => resolve(module))
const WeixinGoodSimple = resolve => import('@/components/other/weixin_good_simple.vue').then(module => resolve(module))

const PathArticleHome = resolve => import('@/components/path/path_article_home.vue').then(module => resolve(module))
const PathArticleNote = resolve => import('@/components/path/path_article_note.vue').then(module => resolve(module))
const PathArticleNoteDetail = resolve => import('@/components/path/path_article_note_detail.vue').then(module => resolve(module))

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {path: '/', component: resolve => import('@/components/home.vue').then(module => resolve(module))},
    {path: '/brand_login', component: BrandArticleLogin},
    {path: '/bigdata_login', component: BrandArticleLogin},
    // 手机端-任务分发
    {path: '/task_path', component: PathArticleHome},
    {path: '/bigdata', component: resolve => import('@/components/report/report_home.vue').then(module => resolve(module))},
    {path: '/task_path_note', component: PathArticleNote},
    {path: '/task_path_note_detail', component: PathArticleNoteDetail},
    // 品牌端
    {path: '/brand', component: BrandArticleHome},
    {path: '/brand_article_note', component: BrandArticleNote},
    {path: '/brand_article_note_detail', component: BrandArticleNoteDetail},

    {path: '/wxtb', component: WeixinGoodSimple},
    // {path: '/', component: resolve => import('@/components/own_writer/pc/own_pc_home').then(module => resolve(module))},
    {path: '/ueditor', component: resolve => import('@/components/own_writer/pc/ueditor').then(module => resolve(module))},
    // {path: '/writer_create', component: resolve => import('@/coreport_homemponents/own_writer/mobile/own_create').then(module => resolve(module))},
    {path: '/writer', component: resolve => import('@/components/own_writer/pc/own_pc_home').then(module => resolve(module))},
    {path: '/edit_writer', component: resolve => import('@/components/own_writer/pc/own_repalc_create.vue').then(module => resolve(module))},
    {path: '/writer_login', component: BrandArticleLogin},
    {path: '/register', component:  resolve => import('@/components/register_account.vue').then(module => resolve(module))},
    {path: '/page_xhs', component: resolve => import('@/components/other/page_xhs').then(module => resolve(module))},
    {
      path: '/koc',
      name: 'Koc',
      component: Koc
    },
    {
      path: '/koc_history',
      name: 'KocHistory',
      component: KocHistory
    },

    // 我的
    {
      path: '/koc_me',
      name: 'Me',
      component: Me
    },
    // 通告详情
    {
      path: '/koc_details',
      name: 'KocDetails',
      component: KocDetails
    },
    // 我的活动
    {
      path: '/koc_me_notice',
      name: 'MeNotice',
      component: MeNotice
    },
    // 笔记素材详情
    {
      path: '/koc_notes_details',
      name: 'NotesDetails',
      component: NotesDetails
    },
    // 账户明细
    {
      path: '/koc_account_details',
      name: 'AccountDetails',
      component: AccountDetails
    },
    // 账户提现
    {
      path: '/koc_account_bank',
      name: 'AccountBank',
      component: AccountBank
    },
    // 笔记素材
    {
      path: '/koc_notes_material',
      name: 'NotesMaterial',
      component: NotesMaterial
    },
    // 上传凭证
    {
      path: '/koc_file_upload',
      name: 'FileUpload',
      component: FileUpload
    },
    {
      path: '/bigdata_login',
      name: 'BrandArticleLogin',
      component: BrandArticleLogin
    },
    // 登录
    {
      path: '/koc_login',
      name: 'BrandArticleLogin',
      component: BrandArticleLogin
    },
    // 联系导师
    {
      path: '/koc_wechat_service',
      name: 'KocWechatService',
      component: KocWechatService
    },
    // 小红书认证
    {
      path: '/koc_xhs_upload',
      name: 'XhsUpload',
      component: XhsUpload
    }
  ]
})
